import { render, staticRenderFns } from "./weightGain.vue?vue&type=template&id=1755a7e0&scoped=true&"
import script from "./weightGain.vue?vue&type=script&lang=js&"
export * from "./weightGain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1755a7e0",
  null
  
)

export default component.exports